/**
 * Per-runner P&L if that selection wins (bookmaker / match odds).
 */
export function calcRunnerPnl(bets, runnerName, allRunnerNames = []) {
  const target = String(runnerName || "").trim().toLowerCase();
  const others = allRunnerNames
    .map((n) => String(n).trim().toLowerCase())
    .filter((n) => n && n !== target);

  let pnl = 0;

  for (const bet of bets) {
    if (bet.status !== "open") continue;
    const sel = String(bet.selection || "").trim().toLowerCase();
    const stake = Number(bet.stake) || 0;
    const win = Number(bet.potentialWin) || 0;
    const isTarget = sel === target;

    if (bet.betType === "back") {
      pnl += isTarget ? win : -stake;
    } else if (bet.betType === "lay") {
      pnl += isTarget ? -win : stake;
    }
  }

  return Math.round(pnl * 100) / 100;
}

export function getMatchBets(bets, matchId) {
  const id = Number(matchId);
  return (bets || []).filter(
    (b) => Number(b.matchId) === id && b.status === "open"
  );
}
